export default __webpack_public_path__ + "static/media/organiser-app.f69f9b55.png";